import { Component, input } from '@angular/core';
import { TableModule } from 'primeng/table';
import { ReportSummaryRowDto } from '../../../../api';
import { CurrencyPipe, NgIf } from '@angular/common';
import { MinutesToHoursPipe } from '../../../../shared/pipes/minutes-to-hours.pipe';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-summary-table',
  imports: [TableModule, CurrencyPipe, MinutesToHoursPipe, NgIf, RouterLink],
  templateUrl: './summary-table.component.html',
  styleUrl: './summary-table.component.css',
})
export class SummaryTableComponent {
  isOwner = input.required<boolean>();
  summaryData = input.required<Array<ReportSummaryRowDto>>();
}
